// Add this to a new JavaScript file in your assets folder
document.addEventListener("DOMContentLoaded", () => {
  // Check if the brochure button exists
  const brochureButton = document.querySelector(".brochure-button-custom")

  // If the button doesn't exist, try to restore it
  if (!brochureButton) {
    // Find the container where the button should be
    const calloutContainer =
      document.querySelector(".veteran-callout-container") || document.querySelector(".veteran-callout").parentNode

    // Check if we already have a brochure download container
    let brochureContainer = document.querySelector(".brochure-download-callout")

    // If not, create one
    if (!brochureContainer) {
      brochureContainer = document.createElement("div")
      brochureContainer.className = "brochure-download-callout"

      // Add it to the callout container
      if (calloutContainer) {
        calloutContainer.appendChild(brochureContainer)
      }
    }

    // Set the content of the brochure container
    brochureContainer.innerHTML = `
      <h3>VA Information Brochure</h3>
      <p>Download our comprehensive guide for veterans about the SitnStand Lift Assist device and VA benefits.</p>
      <a href="/path-to-your-brochure.pdf" 
         class="brochure-button-custom" 
         download
         target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="download-icon">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
        Download Brochure
      </a>
    `

    // Style the button as pill-shaped
    const newButton = brochureContainer.querySelector(".brochure-button-custom")
    if (newButton) {
      newButton.style.borderRadius = "9999px"
      newButton.style.display = "inline-flex"
      newButton.style.alignItems = "center"
      newButton.style.justifyContent = "center"
      newButton.style.padding = "12px 20px"
      newButton.style.backgroundColor = "#2563eb"
      newButton.style.color = "white"
      newButton.style.fontWeight = "500"
      newButton.style.fontSize = "16px"
      newButton.style.fontFamily = '"Fira Sans", sans-serif'
      newButton.style.textDecoration = "none"
      newButton.style.transition = "all 0.3s ease"
      newButton.style.border = "2px solid #2563eb"
      newButton.style.gap = "8px"
      newButton.style.width = "100%"
      newButton.style.textAlign = "center"

      // Add hover effect
      newButton.addEventListener("mouseenter", function () {
        this.style.backgroundColor = "#1d4ed8"
        this.style.transform = "translateY(-2px)"
        this.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)"
      })

      newButton.addEventListener("mouseleave", function () {
        this.style.backgroundColor = "#2563eb"
        this.style.transform = "none"
        this.style.boxShadow = "none"
      })
    }
  }

  // Fix gallery images if they're missing
  const gallerySlides = document.querySelectorAll(".gallery-slide")
  gallerySlides.forEach((slide) => {
    const img = slide.querySelector("img")
    if (img && (!img.src || img.src === "undefined" || img.src.includes("missing_image"))) {
      // Set a placeholder image
      img.src = "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png"
    }
  })
})
